module.exports = __webpack_public_path__ + "static/media/contact-btn-teal.1bc0c366.svg";